import React, { memo } from 'react';
import { Handle, Position } from '@xyflow/react';
import { Clock, Hourglass } from 'lucide-react';
import { useTheme } from '../ThemeContext';

export const DelayNode = memo(({ data, selected }) => {
  const { isDark } = useTheme();

  return (
    <div className={`w-64 rounded-xl border transition-all ${
      isDark ? 'bg-slate-900 border-slate-800 shadow-xl' : 'bg-white border-slate-200 shadow-lg'
    } ${
      selected ? 'border-teal-500 ring-2 ring-teal-500/30' : (isDark ? 'hover:border-slate-700' : 'hover:border-slate-300')
    }`}>
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        className={`!h-3.5 !w-3.5 !border-2 !bg-teal-500 hover:!scale-125 transition-transform ${
          isDark ? '!border-slate-900' : '!border-white'
        }`}
      />

      <div className={`flex items-center justify-between rounded-t-xl px-3.5 py-2.5 border-b ${
        isDark
          ? 'bg-gradient-to-r from-teal-950/80 to-teal-900/40 border-teal-500/20'
          : 'bg-gradient-to-r from-teal-50 to-emerald-50 border-teal-200'
      }`}>
        <div className="flex items-center gap-2">
          <div className={`flex h-6 w-6 items-center justify-center rounded-lg ${
            isDark ? 'bg-teal-500/20 text-teal-400' : 'bg-teal-100 text-teal-700'
          }`}>
            <Clock className="h-3.5 w-3.5" />
          </div>
          <span className={`text-xs font-bold uppercase tracking-wider ${
            isDark ? 'text-teal-200' : 'text-teal-900'
          }`}>
            {data.label || 'Time Delay'}
          </span>
        </div>
        <span className={`rounded px-1.5 py-0.5 text-[10px] font-medium ${
          isDark ? 'bg-teal-500/10 text-teal-300' : 'bg-teal-100 text-teal-700'
        }`}>
          DRIP
        </span>
      </div>

      <div className={`p-3.5 flex items-center gap-2.5 text-xs ${isDark ? 'text-slate-300' : 'text-slate-700'}`}>
        <Hourglass className="h-4 w-4 text-teal-500 animate-pulse" />
        <div>
          <span className={isDark ? 'text-slate-400' : 'text-slate-500'}>Wait for: </span>
          <span className={`font-semibold ${isDark ? 'text-white' : 'text-slate-900'}`}>{data.duration || '24'} {data.unit || 'hours'}</span>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        id="output"
        className={`!h-3.5 !w-3.5 !border-2 !bg-teal-500 hover:!scale-125 transition-transform ${
          isDark ? '!border-slate-900' : '!border-white'
        }`}
      />
    </div>
  );
});
